import React from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { Box } from '@material-ui/core'
import { CoreButton } from 'src/components/core'
import AddIcon from '@material-ui/icons/Add'
import { withStyles } from '@material-ui/core/styles'
import SectionHeader from './SectionHeader'
import Module from './Page'
import styles from '../styles'

const Section = ({
  classes,
  section,
  sectionIndex,
  expandedModules,
  sectionTitleRefs,
  moduleTitleRefs,
  goalRefs,
  popupStates,
  anchorElements,
  fieldSuggestions,
  popupLoadingStates,
  sectionMenuAnchor,
  onSectionTitleChange,
  onSectionMenuOpen,
  onSectionMenuClose,
  onSectionAction,
  onSectionTitleSuggestions,
  sectionTitleSuggestions,
  onModuleTitleChange,
  onPageTitleSuggestions,
  pageTitleSuggestions,
  onToggleModule,
  onAddGoal,
  onRemoveGoal,
  onGoalChange,
  onGoalFocus,
  onRegenerateSuggestions,
  onPopupClose,
  onSuggestionClick,
  onAddPage,
  onDeletePage,
  getFileInfo,
  onGoalKeyDown,
  documentFollowing,
  setDocumentFollowing,
}) => {
  return (
    <Draggable
      key={`section-${sectionIndex}`}
      draggableId={`section-${sectionIndex}`}
      index={sectionIndex}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={classes.sectionContainer}
        >
          <SectionHeader
            classes={classes}
            section={section}
            sectionIndex={sectionIndex}
            sectionTitleRefs={sectionTitleRefs}
            sectionMenuAnchor={sectionMenuAnchor}
            onSectionTitleChange={onSectionTitleChange}
            onSectionMenuOpen={onSectionMenuOpen}
            onSectionMenuClose={onSectionMenuClose}
            onSectionAction={onSectionAction}
            onSectionTitleSuggestions={onSectionTitleSuggestions}
            sectionTitleSuggestions={sectionTitleSuggestions}
            dragHandleProps={provided.dragHandleProps}
          />

          <Box className={classes.sectionContent}>
            <Droppable droppableId={`modules-${sectionIndex}`} type="MODULE">
              {(provided, snapshot) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {section.modules.map((module, moduleIndex) => (
                    <Module
                      key={`module-${sectionIndex}-${moduleIndex}`}
                      classes={classes}
                      module={module}
                      sectionIndex={sectionIndex}
                      moduleIndex={moduleIndex}
                      expandedModules={expandedModules}
                      moduleTitleRefs={moduleTitleRefs}
                      goalRefs={goalRefs}
                      popupStates={popupStates}
                      anchorElements={anchorElements}
                      fieldSuggestions={fieldSuggestions}
                      popupLoadingStates={popupLoadingStates}
                      onModuleTitleChange={onModuleTitleChange}
                      onPageTitleSuggestions={onPageTitleSuggestions}
                      pageTitleSuggestions={pageTitleSuggestions}
                      onToggleModule={onToggleModule}
                      onAddGoal={onAddGoal}
                      onRemoveGoal={onRemoveGoal}
                      onGoalChange={onGoalChange}
                      onGoalFocus={onGoalFocus}
                      onRegenerateSuggestions={onRegenerateSuggestions}
                      onPopupClose={onPopupClose}
                      onSuggestionClick={onSuggestionClick}
                      onAddPage={onAddPage}
                      onDeletePage={onDeletePage}
                      getFileInfo={getFileInfo}
                      onGoalKeyDown={onGoalKeyDown}
                      documentFollowing={documentFollowing}
                      setDocumentFollowing={setDocumentFollowing}
                    />
                  ))}
                  {provided.placeholder}

                  <CoreButton
                    variant="text"
                    size="small"
                    color="secondary"
                    startIcon={<AddIcon fontSize="small" />}
                    onClick={() => onAddPage(sectionIndex)}
                  >
                    Add a Page
                  </CoreButton>
                </div>
              )}
            </Droppable>
          </Box>
        </div>
      )}
    </Draggable>
  )
}

export default withStyles(styles)(Section)
